export default __webpack_public_path__ + "static/media/glrc-course.intro-to-kitchen.49fb4996.png";